import React, { useRef, useEffect } from "react";
import classes from "./style.module.scss";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../component/Button";
import { FormProvider, useForm, } from "react-hook-form";
import TimePickerComponent from "../../component/TimePickerComponent";
import TimeClockPickerComponent from "../../component/TimeClockPickerComponent"
import DateSelector from "../../component/DateSelector";
import moment from "moment";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { useDispatch } from "react-redux";
import FileUpload from "../../component/FileUpload";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const ScheduleNotifications = (props) => {
  const {
    isOpen = false,
    notifyData,
    closePopUp,
    handleSuccessModal,
    getNotificationList,
    notification_id,
    isEditDate,
  } = props;
  const selectBoxRef = useRef();
  const dispatch = useDispatch();
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const formMethods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    trigger,
    watch,
    setValue,
  } = formMethods;

  useEffect(() => {
    if (!isEditDate) {

      const dubaiTime = dayjs().tz('Asia/Dubai');
      const dubaiTimePlusOneHour = dubaiTime.add(1, 'hour');
      const timeValue = dubaiTimePlusOneHour.format('hh:mm A');
      setValue("scheduled_time", timeValue);
    }
  }, [setValue, isEditDate]);

  useEffect(() => {
    if (notification_id && isEditDate) {
      getDetails(notification_id);
    }
  }, [notification_id]);

  const getDetails = async (notification_id) => {
    let url = `${Exported.Endpoints.getNotificationDetails}`;
    let paramsObj = {
      notification_id: notification_id,
    };
    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          let detailInfo = res?.data?.data;
          setValue("scheduled_date", detailInfo?.scheduled_date || null);
          setValue("scheduled_time", detailInfo?.scheduled_time || null);
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
  };
  
  const selectedDate = watch("scheduled_date");
  const now = dayjs();
  const isToday = selectedDate && dayjs(selectedDate).isSame(now, "day");
  const minTime = isToday ? now : null;
  
  const onSubmit = async (data) => {
    trigger();
    dispatch(saveLoadingState(true));

    let paramsObj = {
      notification_id: notification_id,
    };

    const { scheduled_date, scheduled_time } = data;
    const formatedTime = scheduled_time?.slice(0,5)

    await request({
      url: `${Exported.Endpoints.getNotificationDetails}`,
      method: isEditDate ? Exported.APIMethods.PUT : Exported.APIMethods.POST,
      data: {
        ...notifyData,
        scheduled_date,
        scheduled_time: formatedTime,
        status : 2,
      },
      params: isEditDate ? { ...paramsObj } : null,
    })
      .then((res) => {
        if (res?.data?.status) {
          dispatch(saveLoadingState(false));
          handleSuccessModal();
          getNotificationList();
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: err?.response?.data?.message || "Unable to process the request!..",
        });
      });

    dispatch(saveLoadingState(false));
  };

  return (
    <>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        selectBoxRef={selectBoxRef}
      >
        <div className={`${classes.scheduleNotificationWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>Schedule for later</div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.reasonFormContainer}`}>
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${classes.formField} !mb-5`}>
                  <DateSelector
                    className={`w-[100%]`}
                    name="scheduled_date"
                    control={formMethods.control}
                    error={errors.scheduled_date}
                    messages={{
                      required: "StartDate is required",
                      validate: "Date must be in YYYY-MM-DD format",
                    }}
                    minDate={moment().format("YYYY-MM-DD")}
                  />
                </div>
                <div>
                  <TimeClockPickerComponent
                    className={`${classes.startTime} w-[100%]`}
                    name="scheduled_time"
                    control={formMethods.control}
                    error={errors.scheduled_time}
                    messages={{ required: "Start Time is required" }}
                    ampm={true}
                    validate={(value) => {
                      if (!value) return "Start Time is required";

                      // Parse the time (expecting 24-hour format like "14:00")
                      const timeMatch = value.match(/^(\d+):(\d+)$/);
                      if (!timeMatch) return "Invalid time format";

                      const hours = parseInt(timeMatch[1], 10);
                      const minutes = parseInt(timeMatch[2], 10);

                      // Get the scheduled date from form
                      const scheduledDate = formMethods.getValues("scheduled_date");
                      const nowDubai = dayjs().tz('Asia/Dubai');

                      console.log("Validating time (24-hour format):", value);
                      console.log("With scheduled date:", scheduledDate);

                      // If we have a scheduled date, use it for validation
                      if (scheduledDate) {
                        // If scheduled date is in the future, time is always valid
                        if (dayjs(scheduledDate).isAfter(nowDubai, 'day')) {
                          return true;
                        }

                        // If scheduled date is today, compare the times
                        if (dayjs(scheduledDate).isSame(nowDubai, 'day')) {
                          const [year, month, day] = scheduledDate.split('-').map(Number);
                          const comparisonDate = dayjs().tz('Asia/Dubai')
                            .year(year)
                            .month(month - 1) // dayjs months are 0-indexed
                            .date(day)
                            .hour(hours)
                            .minute(minutes)
                            .second(0);

                          return comparisonDate.isAfter(nowDubai) ||
                            "Selected time must not be in the past in Dubai";
                        }
                      } else {
                        // No scheduled date, validate against today
                        const comparisonDate = dayjs().tz('Asia/Dubai')
                          .hour(hours)
                          .minute(minutes)
                          .second(0);

                        return comparisonDate.isAfter(nowDubai) ||
                          "Selected time must not be in the past in Dubai";
                      }

                      return true;
                    }}
                  />
                </div>
                <div className="flex justify-end">
                  <Button text={"Save"} className={`w-[100%] my-4`} smallBtn />
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default ScheduleNotifications;
